export interface PrintImageData {
	src: string;
	alt?: string | null;
}

type PrintImageNode = {
	relationships?: {
		field_print_image?: {
			field_media_image?: {
				alt?: string | null;
			} | null;
			relationships?: {
				field_media_image?: {
					uri?: {
						url?: string | null;
					} | null;
					childImageKitAsset?: {
						fluid?: {
							images?: {
								fallback?: {
									src?: string | null;
								} | null;
							} | null;
						} | null;
					} | null;
				} | null;
			} | null;
		} | null;
	} | null;
};

export const extractPrintImageData = (
	node?: PrintImageNode | null,
): PrintImageData | null => {
	const printImage = node?.relationships?.field_print_image;
	const mediaFile = printImage?.relationships?.field_media_image;

	// Prefer ImageKit fluid when GraphQL resolved it; fall back to the file URI
	// for article encryptedSections, which serialize raw nodes without fluid.
	const src =
		mediaFile?.childImageKitAsset?.fluid?.images?.fallback?.src ||
		mediaFile?.uri?.url;

	if (!src) return null;

	return {
		src,
		alt: printImage?.field_media_image?.alt,
	};
};
